<template>
  <div>
    <Card :bordered="false" dis-hover>
      <p slot="title">试压员联系信息</p>
      <van-cell-group>

            <van-cell title="姓名" v-model="name" />
            <van-cell title="电话" v-model="tel" clickable="true" />

      </van-cell-group>
    </Card>

  </div>
</template>

<script>
export default {
  data() {
    return {
      name:"",
      tel: "",

    };
  },
  created() {
    var workerid = this.$route.params.id;
    this.$http
        .get("prepress/GetWorkerInfo?workerID=" + workerid)
        .then((res) => {
        if (res.data.Msg == "success") {
            this.name=res.data.Data.Name;
            this.tel=res.data.Data.TelNum;

        }
        });
    
    // if (presaleID != undefined) {
    //   this.scense = 1;
    // console.log(this.presaleID);
  },
  methods: {

  },
};
</script>

<style>
</style>
